import { getConfig } from '../core/config';

export interface LogEntry {
  level: string;
  message: string;
  timestamp: string;
  stack?: string;
}

const buffer: LogEntry[] = [];
let intercepting = false;

const originalConsole: Record<string, (...args: unknown[]) => void> = {};

function serialize(arg: unknown): string {
  if (arg === null) return 'null';
  if (arg === undefined) return 'undefined';
  if (typeof arg === 'string') return arg;
  if (arg instanceof Error) return `${arg.name}: ${arg.message}`;
  try {
    return JSON.stringify(arg, null, 0);
  } catch {
    return String(arg);
  }
}

export function startConsoleInterceptor(): void {
  if (intercepting) return;
  intercepting = true;

  const levels = ['log', 'warn', 'error', 'info'] as const;

  for (const level of levels) {
    originalConsole[level] = console[level].bind(console);

    (console as unknown as Record<string, (...args: unknown[]) => void>)[level] = (...args: unknown[]) => {
      const entry: LogEntry = {
        level,
        message: args.map(serialize).join(' '),
        timestamp: new Date().toISOString(),
      };

      if (level === 'error') {
        entry.stack = new Error().stack;
      }

      buffer.push(entry);
      const max = getConfig().maxLogs;
      while (buffer.length > max) buffer.shift();

      originalConsole[level](...args);
    };
  }
}

export function stopConsoleInterceptor(): void {
  if (!intercepting) return;
  intercepting = false;

  for (const [level, fn] of Object.entries(originalConsole)) {
    (console as unknown as Record<string, (...args: unknown[]) => void>)[level] = fn;
  }
}

export function getConsoleLogs(): LogEntry[] {
  return [...buffer];
}

export function getOriginalConsole(): Record<string, (...args: unknown[]) => void> {
  return originalConsole;
}
